import type { FC } from 'react';
import React, { useContext } from 'react';

import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component.ts';
import { LoadableLazy } from '@confluence/loadable';
import {
	useNetworkStatusListenerCache,
	ClientNetworkStatus,
} from '@confluence/legacy-schema-bridge/entry-points/useNetworkStatusListenerCache.ts';

const NetworkStatusFlagLoader = LoadableLazy({
	loader: () =>
		import(/* webpackChunkName: "loadable-NetworkStatusFlag" */ './NetworkStatusFlag.tsx').then(
			(module) => module.NetworkStatusFlagWithFlags,
		),
});

export const NetworkStatusListener: FC = () => {
	const networkStatus = useNetworkStatusListenerCache();
	// 1. experience-tracker
	const experienceTracker = useContext(ExperienceTrackerContext);
	let reason: string | undefined;

	switch (networkStatus) {
		case ClientNetworkStatus.IP_BLOCKED:
			reason = 'IP blocked';
			break;
		case ClientNetworkStatus.OFFLINE:
			reason = 'Network unavailable';
			break;
	}
	if (reason) {
		experienceTracker.abort({
			reason,
			checkForTimeout: false,
		});
	}

	// 2. flags
	return <NetworkStatusFlagLoader status={networkStatus} />;
};
